var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBar
    ? _c("div", { staticClass: "team-portal-bar" }, [
        _c("div", { staticClass: "team-portal-bar-content" }, [
          _c("span", { staticClass: "team-portal-bar-text" }, [
            _vm._v(
              "\n            The new Team Portal is here — a faster, modern experience for managing your team.\n        "
            ),
          ]),
          _c(
            "a",
            {
              staticClass: "team-portal-bar-link",
              attrs: {
                href: _vm.teamPortalUrl,
                target: "_blank",
                rel: "noopener",
              },
            },
            [
              _vm._v("\n            Switch to Team Portal\n            "),
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                  },
                },
                [
                  _c("path", { attrs: { d: "M7 17L17 7" } }),
                  _c("path", { attrs: { d: "M7 7h10v10" } }),
                ]
              ),
            ]
          ),
        ]),
        _c(
          "button",
          {
            staticClass: "team-portal-bar-dismiss",
            attrs: { "aria-label": "Dismiss" },
            on: { click: _vm.dismiss },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [
                _c("line", { attrs: { x1: "18", y1: "6", x2: "6", y2: "18" } }),
                _c("line", { attrs: { x1: "6", y1: "6", x2: "18", y2: "18" } }),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }